<template>
  <v-row>
    <AdviserDetailDialog :adviser="selected"
                         v-model="showAdviserDetailsDialog"
                         v-if="showAdviserDetailsDialog">
    </AdviserDetailDialog>

    <CreateEditOwnerAdviser @clear="selected = null"
                            :selected="selected"
                            type="adviser"
                            v-model="showCreateEditOwnerAdviser">
    </CreateEditOwnerAdviser>

    <v-col cols="12">
      <v-row class="px-3" align="center">
        <v-text-field clearable
                      label="Buscar"
                      :loading="loading"
                      v-model="search">
        </v-text-field>

        <v-btn color="abadPrimary"
               class="ml-3"
               @click="showCreateEditOwnerAdviser = true"
               dark>
          Crear asesor
        </v-btn>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-data-table class="elevation-2 custom-table"
                    :headers="headers"
                    :items="advisers"
                    :footer-props="footerProps"
                    :search="search"
                    calculate-widths>
        <template v-slot:item.acciones="{ item }">
          <td class="d-flex justify-center align-center">
            <v-icon class="mr-3" @click="editAdviser(item)">
              mdi-pencil
            </v-icon>
            <v-icon @click="viewAdviser(item)">
              mdi-eye
            </v-icon>
          </td>
        </template>

        <template v-slot:item.nodata>
          <v-row>
            <v-col class="text-center" cols="12" v-if="loading">
              Cargando asesores
            </v-col>
            <v-col cols="12" class="red--text text-center" v-else>
              No hay asesores registrados
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import AdviserDetailDialog from '@/pages/RealEstate/components/AdviserDetailsDialog.vue'
import CreateEditOwnerAdviser from '@/pages/RealEstate/components/CreateEditOwnerAdviser.vue'
export default {
  components: {
    AdviserDetailDialog,
    CreateEditOwnerAdviser
  },
  computed: {
    ...mapState({
      advisers: state => state.realEstate.advisers
    })
  },
  created () {
    this.getRealEstateAdvisers()
  },
  data: () => ({
    footerProps: {
      'items-per-page-options': [],
      'items-per-page-text': 'Propiedades por pagina'
    },
    headers: [
      { text: 'Cédula', value: 'cedula' },
      { text: 'Nombres', value: 'nombres' },
      { text: 'Celular', value: 'celular' },
      { text: 'Fijo', value: 'fijo' },
      { text: 'Email', value: 'email' },
      { text: '', value: 'acciones' }
    ],
    loading: false,
    search: '',
    selected: null,
    showAdviserDetailsDialog: false,
    showCreateEditOwnerAdviser: false,
    totalAdvisers: 0,
    title: '',
    edit: 0
  }),
  methods: {
    async getRealEstateAdvisers () {
      this.loading = true
      await this.$store.dispatch('getRealEstateAdvisers')
      this.loading = false
    },
    viewAdviser (adviser) {
      this.selected = adviser
      this.showAdviserDetailsDialog = true
    },
    editOwner (adviser) {
      this.selected = adviser
      this.showCreateEditOwnerAdviser = true
    },
    editAdviser (adviser) {
      this.selected = adviser
      this.showCreateEditOwnerAdviser = true
      this.title = 'Editar Asesor'
      this.edit = 1
      console.log(adviser)
    }
  }
}
</script>
